import React from "react";
import { Reveal } from "@/components/util/Reveal";

export const CredibilityStatement = () => (
  <section data-testid="credibility-statement" className="bg-[#0F0F0F] pb-20 sm:pb-24">
    <div className="max-w-[1400px] min-[1440px]:max-w-[1720px] mx-auto px-4 sm:px-6 lg:px-10 min-[1440px]:px-[clamp(2.5rem,4vw,4rem)]">
      <Reveal className="border-t border-[#1F1F1F] pt-14 sm:pt-16 grid lg:grid-cols-[auto_1fr] gap-6 lg:gap-16 items-end">
        <h2
          data-testid="credibility-years"
          className="font-display font-black uppercase tracking-tight leading-[0.85] text-[72px] sm:text-[120px] lg:text-[156px] min-[1440px]:text-[184px]"
        >
          <span className="text-white">20+</span> <span className="text-[#FF6600]">Years.</span>
        </h2>
        <div className="lg:pb-4 max-w-xl">
          <p data-testid="credibility-tagline" className="font-display font-black text-white text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Still creating. Still evolving.
          </p>
          <p data-testid="credibility-body" className="mt-4 text-[#A3A3A3] text-base sm:text-lg leading-relaxed">
            Independent creative thinking since 2005. From emerging businesses to established Caribbean brands.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
